import {put, takeLatest, call} from 'redux-saga/effects';
import * as imageService from "../../../services/imageService"
import {
    ADD_IMAGE,
    ADD_IMAGE_SUCCESS,
    ADD_IMAGE_ERROR
}
    from "../../actions/image";

function* addImageSaga(action) {
    try {
        const data =  yield call(imageService.AddImage, action.payload)
        yield put({
            type: ADD_IMAGE_SUCCESS,
            payload: data
        });

    } catch (error) {
        yield put({
            type: ADD_IMAGE_ERROR,error: error.data
        });
    }
}

export function* addImageSagaWatcher() {
    yield takeLatest(ADD_IMAGE, addImageSaga);
}